import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { OrderPreviewWrapperContainer } from './styled';
import { DataTestAttributes } from '../../constants/DataTestAttributes';
import { OrderSummary } from '@chegg/commerce-utils';
import { useAppSelector } from '../../hooks/useAppSelector';
import { configSelector } from '../../redux/config/config.selectors';
export var OrderPreviewWrapper = function OrderPreviewWrapper(_ref) {
  var taxInfo = _ref.taxInfo,
    price = _ref.price;
  var stateConfig = useAppSelector(configSelector);
  var orderSummaryContent = stateConfig.content.orderSummaryContent;
  var effectivePrice = _objectSpread(_objectSpread({}, price), {}, {
    tax: taxInfo.tax !== 0 ? taxInfo.taxTotalWithCurrency : '',
    total: taxInfo.priceTotalWithTaxCurrency
  });
  var content = _objectSpread({}, orderSummaryContent);
  var noOp = function noOp() {};
  return /*#__PURE__*/React.createElement(OrderPreviewWrapperContainer, {
    id: "preview-container",
    "data-test": DataTestAttributes.ORDER_PREVIEW_WRAPPER
  }, /*#__PURE__*/React.createElement(OrderSummary, {
    price: effectivePrice,
    content: content,
    onError: noOp,
    formattedTotalWithTax: effectivePrice.total,
    "data-test": DataTestAttributes.ORDER_SUMMARY
  }));
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/dropin-payments/dist/esm/components/OrderPreviewWrapper/OrderPreviewWrapper.js
// module id = 4664
// module chunks = 11